module.exports = __webpack_public_path__ + "static/media/learning-21.c737c3cb.png";